import { Pipe, PipeTransform } from '@angular/core';
import { PlanwertStatus } from '../../domain/model/planwert-status.enum';

@Pipe({
    name: 'planwertStatus',
    standalone: false,
})
export class PlanwertStatusPipe implements PipeTransform {

    transform(value: PlanwertStatus): string {
        switch (value) {
            case PlanwertStatus.OPEN:
                return 'Offen';
            case PlanwertStatus.PROCESSED:
                return 'Übernommen';
            case PlanwertStatus.SYSTEM_FAILED:
                return 'Systemfehler';
            case PlanwertStatus.INVALID:
                return 'Ungültig';
        }
        return value;
    }
}
